exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".apps_bay_sms_manager_dashboard_selector[data-v-4885a1ad]{position:relative}", ""]);

// exports
